<template>
	<PageArrows 
		v-bind:className="'patient final'"
		v-bind:linkPrev="`/patient/${which}/${content[which].prevTab}`"
	></PageArrows>
	<div id="container">
		<img v-bind:width="content[this.which].final" v-bind:src="require(`@/assets/patients/${which}/final/final.png`)" />
	</div>
</template>
<script>
import PageArrows from '@/components/PageArrows'
export default {
	components: {
		PageArrows
	},
	data() {
		return {
			which: this.$route.params.which,
			tabType: 'final',
			content: {
				bishop: {
					prevTab: 'ramp-up/',
					final: 946
				},
				carson: {
					prevTab: 'cycle-3/',
					final: 946
				},
				pierce: {
					prevTab: 'cycle-1/',
					final: 946
				},
				gordon: {
					prevTab: 'cycle-4/',
					final: 946
				}
			}
		}
	}
}
</script>